export const ReportTableColumn=[
    {
        id: "S.No",
        label: "S.No",
        minWidth: 70,
        align: "left",
    },
    {
        id: "exploreremail",
        label: "Explorer Email",
        minWidth: 70,
        align: "center",
    },
    {
        id: "buddyemail",
        label: "Buddy Email",
        minWidth: 70,
        align: "center",
    },
    {
        id: "comment",
        label: "Comment",
        minWidth: 70,
        align: "center",
    },
    {
        id: "createdAt",
        label: "Date",
        minWidth: 70,
        align: "center",
    },
    {
        id: "active",
        label: "Active",
        minWidth: 70,
        align: "center",
    }
]